// import { ButtonRounded } from "../..";
import styles from "./AppCrashedPage.module.scss";
import { displayErrorFn } from "../../../../features/src/ErrorBoundary/utils/displayError.tool";

export interface AppCrashedPageProps {
    componentStack: string;
    error: any;
    resetError: () => void;
    codeError: string | number
}

export function AppCrashedPage(props: AppCrashedPageProps): JSX.Element {
    const { componentStack, error, resetError, codeError } = props;

    const displayError = displayErrorFn();

    if (error.toString().includes("Failed to fetch dynamically imported module")) {
        window.location.reload();
    }

    return (
        <div className={styles["AppCrashed"]}>
            <div className={styles["card"]}>
                <h1>
                    L'application a rencontrée une erreur inattendue
                </h1>

                <p>
                    Nous sommes sincèrement désolés mais l'application vient de rencontrer une erreur<br />
                    Vous pouvez essayer d'effacer l'erreur automatiquement en réinitialisant<br />
                    Si cela ne résout rien, veuillez naviguer vers le menu principal
                </p>

                <div className={styles["line"]}>
                    <button onClick={() => resetError()}>
                        Reinitialiser
                    </button>

                    <button onClick={() => window.location.href = "/"}>
                        Revenir au menu principal
                    </button>
                </div>

                <div className={styles["error"]}>
                    {displayError &&
                        <>
                            <h3>Erreur rencontrée : </h3>
                            <p>{error.toString()}</p>
                        </>
                    }
                    <p>Code erreur : {codeError}</p>
                    {displayError &&
                        <>
                            <h3>StackTrace</h3>
                            <p className={styles["stackTrace"]}>
                                {componentStack}
                            </p>
                        </>
                    }
                </div>

            </div >
        </div>
    );
}
